<template>
  <div class="secret-reveal-panel">
    <el-row>
      <el-col
        v-if="config?.title"
        :span="24"
        class="secret-reveal-panel__header"
      >
        <PDivider :label="config.title" class="secret-reveal-panel__divider" />
      </el-col>
      <el-col v-if="config?.message" :span="24">
        <PBannerBase type="info">
          <template #title>
            <div class="secret-reveal-panel__message">
              {{ config.message }}
            </div>
          </template>
        </PBannerBase>
      </el-col>
      <el-col :span="24" class="secret-reveal-panel__value">
        <div class="secret-reveal-panel__value-row">
          <div class="secret-reveal-panel__input">
            <PInput
              :model-value="value"
              :label="config?.valueLabel ?? ''"
              readonly
              full
            />
          </div>
          <PButton
            type="primary"
            suffix-icon="content_copy"
            @click="copySecret"
          >
            Copiar
          </PButton>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup lang="ts">
import { PBannerBase, PButton, PDivider, PInput } from "@f360-dev/f360-prisma";
import { TIntegracaoActionSecretDialog } from "../../services/CadastroDeIntegracaoGateway";

const props = defineProps<{
  config: TIntegracaoActionSecretDialog | null;
  value: string;
}>();

const emit = defineEmits<{
  (e: "copied"): void;
}>();

const copySecret = async () => {
  await navigator.clipboard.writeText(props.value);
  emit("copied");
};
</script>

<style scoped lang="scss" src="./SecretRevealPanel.scss"></style>
